import React from 'react';
import {styled} from '@mui/material/styles';

const PullChordSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="39.465"
    height="35.167"
    viewBox="0 0 39.465 35.167"
    {...props}
  >
    <g
      id="Group_4511"
      data-name="Group 4511"
      transform="translate(-4660.729 14313.972)"
    >
      <g
        id="Group_4510"
        data-name="Group 4510"
        transform="translate(4660.729 -14313.972)"
      >
        <path
          id="Path_30088"
          data-name="Path 30088"
          d="M36.04,252.729a3.428,3.428,0,0,1-3.424-3.425H34.26a1.78,1.78,0,1,0,1.78-1.78H3.425a1.78,1.78,0,1,0,1.78,1.78H6.849a3.425,3.425,0,1,1-3.424-3.424H36.04a3.425,3.425,0,1,1,0,6.849"
          transform="translate(0 -217.562)"
        />
        <path
          id="Path_30089"
          data-name="Path 30089"
          d="M39.464,243.179H37.82V214.862a1.783,1.783,0,0,0-1.781-1.781H3.425a1.783,1.783,0,0,0-1.781,1.781v28.317H0V214.862a3.429,3.429,0,0,1,3.425-3.425H36.039a3.429,3.429,0,0,1,3.425,3.425Z"
          transform="translate(0 -211.437)"
        />
        <rect
          id="Rectangle_1910"
          data-name="Rectangle 1910"
          width="5.09"
          height="1.644"
          transform="translate(30.52 21.658)"
        />
        <rect
          id="Rectangle_1911"
          data-name="Rectangle 1911"
          width="5.09"
          height="1.644"
          transform="translate(30.52 24.33)"
        />
        <path
          id="Icon_material-alarm-on"
          data-name="Icon material-alarm-on"
          d="M18.907,5.86,15.248,2.79,14.222,4.007l3.659,3.07ZM7.677,4.007,6.659,2.79,3,5.852,4.026,7.069Zm3.277.485a7.158,7.158,0,1,0,7.158,7.158A7.159,7.159,0,0,0,10.953,4.492Zm0,12.725a5.567,5.567,0,1,1,5.567-5.567A5.563,5.563,0,0,1,10.953,17.217Zm-1.161-4.35L8.1,11.173l-.843.843,2.529,2.529,4.772-4.772-.843-.843L9.792,12.867Z"
          transform="translate(8.779 5.072)"
        />
      </g>
    </g>
  </svg>
);
const CssPullChordSvg = styled(PullChordSvg)(({theme}) => ({
  fill: theme.palette.text.secondary,
  height: 'auto',
  maxHeight: 'calc(1vh + 1.7vw)',
  width: ' 100%',
}));

export default CssPullChordSvg;
